(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["article-product-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    window.Alpine.data('articleProductCarousel', () =>
      window.theme.scrollCarousel({ trackSelector: '[data-apc-track]' })
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brand-letter-filter"] && !Shopify.designMode) return;
  try {
    if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }

  function register() {
    if (!window.Alpine || window.Alpine.__brandLetterFilterRegistered) return;
    window.Alpine.__brandLetterFilterRegistered = true;

    window.Alpine.data('brandLetterFilter', () => ({
      activeLetter: null,
      available: [],
      count: 0,
      total: 0,
      buckets: [],

      init() {
        const target = document.querySelector('.brand-az-index');
        if (!target) return;
        this.buckets = Array.from(target.querySelectorAll('[data-letter]'));
        this.available = this.buckets.map((b) => b.dataset.letter);
        this.total = target.querySelectorAll('.brand-link').length;
        this.count = this.total;
      },

      jumpTo(letter) {
        if (!this.available.includes(letter)) return;
        this.activeLetter = letter;
        const bucket = this.buckets.find((b) => b.dataset.letter === letter);
        if (!bucket) return;
        const stickyHeaderH = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-h'),
          10
        ) || 0;
        const y = bucket.getBoundingClientRect().top + window.scrollY - stickyHeaderH - 8;
        window.scrollTo({ top: y, behavior: 'smooth' });
      },
    }));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brand-rotating-card"] && !Shopify.designMode) return;
  try {
    if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }

  function register() {
    if (!window.Alpine || window.Alpine.__brandRotatingCardRegistered) return;
    window.Alpine.__brandRotatingCardRegistered = true;

    window.Alpine.data('brandRotatingCard', (config = {}) => ({
      intervalMs: config.intervalMs ?? 3000,
      pauseOnHover: config.pauseOnHover ?? true,
      currentIndex: 0,
      slides: [],
      reducedMotion: null,
      observer: null,
      timer: null,
      _onRMChange: null,
      _onMouseEnter: null,
      _onMouseLeave: null,
      _onFocusIn: null,
      _onFocusOut: null,

      init() {
        this.slides = Array.from(this.$el.querySelectorAll('[data-rotating-card-slide]'));
        if (this.slides.length === 0) return;

        if (this.slides.length === 1) {
          this.$el.setAttribute('data-single-slide', '');
          this.slides[0].setAttribute('data-active', '');
          return;
        }

        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('data-active', i === 0);
        });

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) this.start();
            else this.stop();
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this.$el);

        if (this.pauseOnHover) {
          this._onMouseEnter = () => this.stop();
          this._onMouseLeave = () => this.start();
          this._onFocusIn = () => this.stop();
          this._onFocusOut = () => this.start();
          this.$el.addEventListener('mouseenter', this._onMouseEnter);
          this.$el.addEventListener('mouseleave', this._onMouseLeave);
          this.$el.addEventListener('focusin', this._onFocusIn);
          this.$el.addEventListener('focusout', this._onFocusOut);
        }

        this._onRMChange = (e) => (e.matches ? this.stop() : this.start());
        this.reducedMotion.addEventListener('change', this._onRMChange);
      },

      destroy() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.reducedMotion && this._onRMChange) {
          this.reducedMotion.removeEventListener('change', this._onRMChange);
        }
        if (this.pauseOnHover) {
          this.$el.removeEventListener('mouseenter', this._onMouseEnter);
          this.$el.removeEventListener('mouseleave', this._onMouseLeave);
          this.$el.removeEventListener('focusin', this._onFocusIn);
          this.$el.removeEventListener('focusout', this._onFocusOut);
        }
      },

      start() {
        if (this.timer || (this.reducedMotion && this.reducedMotion.matches)) return;
        this.timer = window.setInterval(() => this.advance(), this.intervalMs);
      },

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      },

      advance() {
        const next = (this.currentIndex + 1) % this.slides.length;
        this.slides[this.currentIndex].removeAttribute('data-active');
        this.slides[next].setAttribute('data-active', '');
        this.currentIndex = next;
      },
    }));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* `Alpine.data('buyButtons', ...)` -- buy-buttons block behaviour.
     Mounts via `x-data="buyButtons"`. Owns three things:
       1. Form submit (`/cart/add.js`) -- dispatches `cart:add`,
          `product:added`, `cart:add:error`.
       2. Bubbled `quantity:change` -> `$store.pdp.quantity` and the
          `[data-product-per-unit]` total refresh.
       3. CTA label + disabled state derived from `$store.pdp` with
          priority `hazardousBlocked -> next-unselected option -> per-variant
          (belowMoqIds || oosIds)`. Liquid renders the
          authoritative initial state and Alpine only patches once
          the product payload has arrived (preserves the MOQ/OOS
          bug fix where init-time recomputes were clobbering "Sold
          out" with the option-only "Add to Bag" path).
     Grid-mode buy buttons skip label mutation entirely. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('buyButtons', () => ({
      _payloadReady: false,
      /* Reactive CTA state — seeded from Liquid in `init()` and updated
         by `refreshCtaState()`. The DOM sync happens in a single
         `x-effect="syncCta()"` on the wrapper, so any change to either
         property re-fires the same central apply routine. */
      ctaLabel: '',
      ctaDisabled: false,

      init() {
        const store = this.$store.pdp;
        store.init(this.sectionRoot());

        /* Seed reactive state from Liquid's initial render so the effect
           runs idempotently on hydration (writes back the same values
           it reads) — no flash, no `x-cloak` needed. */
        const initialLabelNode = this.$root.querySelector('[data-product-atc-cta] .button__label');
        if (initialLabelNode) this.ctaLabel = initialLabelNode.textContent.trim();
        this.ctaDisabled = this.$root.dataset.oos === 'true';

        document.addEventListener('pdp:payload', () => {
          this._payloadReady = true;
          this.refreshCtaState();
        });

        this.$root.addEventListener('quantity:change', (event) => {
          const value = Number(event.detail && event.detail.value) || store.moqMin;
          store.quantity = value;
          this.refreshPerUnit();
        });

        const form = this.$root.querySelector('[data-product-form]');
        if (form) {
          form.addEventListener('submit', (event) => this.onSubmit(event, form));
        }

        document.addEventListener('main-options:change', (event) => {
          const detail = event.detail || {};
          if (detail.productId && store.productId && detail.productId !== store.productId) {
            return;
          }
          if (this._payloadReady) this.refreshCtaState();
        });

        /* React to variant changes: push the new effective cap onto the
           qty selector AND re-derive the CTA label. The
           `main-options:change` listener above fires BEFORE the picker
           writes the new variantId, so on its own it computes against
           a stale id; this watch closes that window. Liquid already
           renders the correct cap + label for the initial variant, so
           we skip the first call -- `$watch` fires only on change. */
        this.$watch('$store.pdp.variantId', () => {
          this.applyVariantMax();
          this.updateRestrictionNotices();
          if (this._payloadReady) this.refreshCtaState();
        });
      },

      sectionRoot() {
        return this.$root.closest('[data-main-product]') || this.$root;
      },

      /* Pure compute: reads `$store.pdp` reactive state + the DOM's
         checked radios (DOM-only state, no way around a querySelector
         here), then writes to reactive `ctaLabel` / `ctaDisabled`.
         `syncCta()` picks up the change via `x-effect` and writes
         DOM in one place. */
      refreshCtaState() {
        if (this.$root.classList.contains('product-buy-buttons--grid')) return;
        const store = this.$store.pdp;
        const sectionRoot = this.sectionRoot();
        const fieldsets = Array.from(
          sectionRoot.querySelectorAll('[data-option-name]')
        ).sort(
          (a, b) =>
            Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
        );

        const nextUnselected = fieldsets.find(
          (fieldset) => !fieldset.querySelector('input[type="radio"]:checked')
        );

        const variantIdStr = store.variantId != null ? String(store.variantId) : '';
        const hazardousBlocked = variantIdStr !== '' && store.hazardousBlockedIds.has(variantIdStr);

        if (hazardousBlocked) {
          this.ctaLabel = store.ctaLabels.hazardousBlocked;
          this.ctaDisabled = true;
        } else if (nextUnselected) {
          const optionName = nextUnselected.dataset.optionName || '';
          this.ctaLabel = store.ctaLabels.selectTemplate.replace('__OPTION__', optionName);
          this.ctaDisabled = true;
        } else {
          /* Membership in the Liquid-rendered oosIds set replaces the
             payload's `variant.available`, which is always true now that
             every variant is natively CONTINUE. channelHiddenIds is the
             add-time channel gate for the resolved variant (deep-links / the
             sole variant) -- disable regardless of stock, same sold-out
             treatment. */
          const belowMoq = variantIdStr !== '' && store.belowMoqIds.has(variantIdStr);
          const unavailable =
            variantIdStr !== '' &&
            (store.oosIds.has(variantIdStr) || store.channelHiddenIds.has(variantIdStr));
          if (belowMoq || unavailable) {
            this.ctaLabel = store.ctaLabels.soldOut;
            this.ctaDisabled = true;
          } else {
            this.ctaLabel = store.ctaLabels.default;
            this.ctaDisabled = false;
          }
        }
      },

      /* Show/hide the bulky + hazardous notices for the active variant.
         The elements are server-rendered whenever ANY variant is
         restricted; membership in the id sets drives visibility. Runs on
         variant change -- Liquid seeds the initial state, so there's no
         first-paint work. */
      updateRestrictionNotices() {
        if (this.$root.classList.contains('product-buy-buttons--grid')) return;
        const store = this.$store.pdp;
        const variantIdStr = store.variantId != null ? String(store.variantId) : '';
        const isBulky = variantIdStr !== '' && store.bulkyIds.has(variantIdStr);
        const isHazardous = variantIdStr !== '' && store.hazardousIds.has(variantIdStr);
        const bulkyNotice = this.$root.querySelector('[data-restriction-notice="bulky"]');
        const hazardNotice = this.$root.querySelector('[data-restriction-notice="hazardous"]');
        if (bulkyNotice) {
          bulkyNotice.classList.toggle('product-buy-buttons__notice--hidden', !isBulky);
        }
        if (hazardNotice) {
          hazardNotice.classList.toggle('product-buy-buttons__notice--hidden', !isHazardous);
        }
      },

      /* Bound via `x-effect="syncCta()"` on the wrapper — Alpine tracks
         the reactive reads (`ctaLabel`, `ctaDisabled`) and re-fires
         whenever either changes. Reads-only from state, writes to DOM. */
      syncCta() {
        if (this.$root.classList.contains('product-buy-buttons--grid')) return;
        const label = this.ctaLabel;
        const disabled = this.ctaDisabled;
        const cta = this.$root.querySelector('[data-product-atc-cta]');
        if (!cta) return;
        const labelNode = cta.querySelector('.button__label');
        const buttonEl = cta.querySelector('button, [type="submit"]');

        if (labelNode && labelNode.textContent !== label) labelNode.textContent = label;
        if (buttonEl) {
          if (disabled) {
            buttonEl.setAttribute('disabled', 'true');
            buttonEl.setAttribute('aria-disabled', 'true');
          } else {
            buttonEl.removeAttribute('disabled');
            buttonEl.removeAttribute('aria-disabled');
          }
        }
        this.$root.classList.toggle('product-buy-buttons--oos', disabled);

        const quantityRoot = this.$root.querySelector('.quantity-selector');
        if (quantityRoot) {
          if (disabled) {
            quantityRoot.setAttribute('data-disabled', '');
          } else {
            quantityRoot.removeAttribute('data-disabled');
          }
          quantityRoot.querySelectorAll('input, button').forEach((node) => {
            if (disabled) node.setAttribute('disabled', 'true');
            else node.removeAttribute('disabled');
          });
        }
      },

      /* Push the active variant's full MOQ rule (floor, increment, cap)
         onto the quantity selector and refresh the "multiples of" notice.
         min/step come from `variantMoqMap` (missing entry = 1/1); the cap
         from `variantMaxMap` (missing = unbounded). Also mirrors min/step
         onto the store so `quantity:change` fallbacks stay in step. */
      applyVariantMax() {
        const qty = this.$root.querySelector('.quantity-selector');
        if (!qty) return;
        const store = this.$store.pdp;
        const idStr = store.variantId != null ? String(store.variantId) : '';
        const cap = idStr && store.variantMaxMap.has(idStr) ? store.variantMaxMap.get(idStr) : '';
        const rule = idStr && store.variantMoqMap.has(idStr) ? store.variantMoqMap.get(idStr) : { min: 1, step: 1 };
        store.moqMin = rule.min;
        store.moqStep = rule.step;
        qty.dispatchEvent(
          new CustomEvent('quantity:set-rule', { detail: { min: rule.min, step: rule.step, max: cap } })
        );
        this.updateMoqNotice(rule.min);
      },

      /* Show/update or hide the "order in multiples of N" notice for the
         active variant, using the localised template published on the CTA
         wrapper (`__MIN__` placeholder). */
      updateMoqNotice(min) {
        const notice = this.$root.querySelector('[data-product-moq-notice]');
        if (!notice) return;
        const cta = this.$root.querySelector('[data-product-atc-cta]');
        const template = cta ? cta.dataset.moqMultiplesTemplate || '' : '';
        if (min > 1 && template) {
          notice.textContent = template.replace('__MIN__', min);
          notice.classList.remove('product-buy-buttons__notice--hidden');
        } else {
          notice.classList.add('product-buy-buttons__notice--hidden');
        }
      },

      refreshPerUnit() {
        const sectionRoot = this.sectionRoot();
        const node = sectionRoot.querySelector('[data-product-per-unit]');
        if (!node) return;
        const quantityRoot = sectionRoot.querySelector('[data-product-quantity]');
        const unit = Number(quantityRoot && quantityRoot.dataset.unitPrice);
        if (!unit) return;
        const total = unit * this.$store.pdp.quantity;
        node.dataset.total = String(total);
        node.setAttribute('data-total-formatted', this.$store.pdp.formatMoney(total));
      },

      onSubmit(event, form) {
        event.preventDefault();
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.setAttribute('disabled', 'true');

        const formData = new FormData(form);
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity')) || 1;
        /* Collect line-item properties from anywhere in the PDP section
           (e.g. a gift-card recipient block whose inputs sit outside this
           form) so they travel with the add. Respect native validity --
           bail to the first invalid field rather than adding an incomplete
           line. Products without property inputs are unaffected. */
        const sectionRoot = this.sectionRoot();
        const properties = {};
        let invalidInput = null;
        sectionRoot.querySelectorAll('[name^="properties["]').forEach((input) => {
          if (input.disabled) return;
          if (typeof input.checkValidity === 'function' && !input.checkValidity()) {
            if (!invalidInput) invalidInput = input;
            return;
          }
          const nameMatch = input.name.match(/^properties\[(.+)\]$/);
          const propValue = (input.value || '').trim();
          if (nameMatch && propValue !== '') properties[nameMatch[1]] = propValue;
        });
        if (invalidInput) {
          if (submitButton) submitButton.removeAttribute('disabled');
          if (typeof invalidInput.reportValidity === 'function') invalidInput.reportValidity();
          return;
        }

        const decClassification = form.dataset.decClassification;
        if (decClassification) {
          properties._dec_classification = decClassification;
        }

        /* Per-variant ceiling (stock / MOQ max) from the store. A variant
           with no entry oversells freely and takes the direct-add path; one
           with an entry must never post more than the cap allows. */
        const store = this.$store.pdp;
        const idStr = String(variantId);
        const cap =
          store.variantMaxMap && store.variantMaxMap.has(idStr)
            ? store.variantMaxMap.get(idStr)
            : null;

        /* Post the add for `finalQty`, then fan out the toast + pixel events.
           Route through the shared serialised cart-write queue so concurrent
           ATC surfaces (quick add, colour cards, GWP) can't overlap Shopify's
           Ajax cart lock and trip a 409. cartAdd resolves with the parsed
           payload; on a 422 (out of stock, not orderable) it rejects with an
           Error whose `.body` holds { status, message, description }.
           `capped` drives the all-in-bag toast wording. */
        const runAdd = (finalQty, capped) => {
          const lineItem = { id: variantId, quantity: finalQty };
          if (Object.keys(properties).length > 0) lineItem.properties = properties;
          const body = JSON.stringify({ items: [lineItem] });
          window.theme
            .cartAdd(body)
            .then((payload) => {
              /* /cart/add.js responds with { items: [...] } — unwrap to the
                 single added line item so listeners (e.g. cart-add-toast) can
                 read item.product_title / item.variant_title / item.image. */
              const item = payload && Array.isArray(payload.items) ? payload.items[0] : payload;
              this.$dispatch('cart:add', { item: item, cappedTo: capped ? cap : null });
              this.$dispatch('product:added', {
                productHandle: this.$store.pdp.handle,
                variantId: this.$store.pdp.variantId,
                quantity: finalQty,
              });
            })
            .catch((err) => {
              /* Surface Shopify's error payload (on err.body) so the error toast
                 reads the same shape the old inline 422 branch dispatched; fall
                 back to the Error itself for network failures. */
              this.$dispatch('cart:add:error', { error: err.body || err });
            })
            .finally(() => {
              if (submitButton) submitButton.removeAttribute('disabled');
            });
        };

        if (cap == null) {
          runAdd(quantity, false);
          return;
        }

        /* Capped variant: clamp the requested quantity to what's still
           addable (cap minus what's already in the cart across all its lines)
           BEFORE the post, so the add never lands with an over-cap quantity
           and the bag badge can't flash a number above the ceiling. Read the
           live cart to learn the current on-hand quantity for this variant. */
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then((res) => res.json())
          .then((cart) => {
            const lines = cart && Array.isArray(cart.items) ? cart.items : [];
            const matching = lines.filter((line) => Number(line.id) === variantId);
            const alreadyInCart = matching.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
            const addable = cap - alreadyInCart;
            if (addable <= 0) {
              /* Ceiling already met — add nothing (a post would only inflate
                 the badge before the cart clamps it back). Still surface the
                 all-in-bag toast off the existing cart line, and skip
                 `product:added` so no phantom add_to_cart is tracked. */
              const item = matching[0] || { product_title: '' };
              this.$dispatch('cart:add', { item: item, cappedTo: cap });
              if (submitButton) submitButton.removeAttribute('disabled');
              return;
            }
            runAdd(Math.min(quantity, addable), quantity > addable);
          })
          .catch(() => {
            /* Cart read failed — fall back to the unclamped add so a network
               blip never blocks a legitimate purchase. */
            runAdd(quantity, false);
          });
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gift-card-balance"] && !Shopify.designMode) return;
  try {
    /* `Alpine.data('giftCardBalance', ...)` - gift card balance lookup.
     Mounts via `x-data="giftCardBalance"` on the block root. Self-contained:
     no shared store, no cart/variant interaction. Reads its config + locale
     strings from data attributes (Liquid is not rendered inside this tag).
     On submit it validates both fields are present, POSTs number + PIN to
     the App Proxy path, and maps the response to the result tile or an
     inline error (422 -> not found, 429 -> rate limited, else -> generic). */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('giftCardBalance', () => ({
      loading: false,
      error: '',
      card: null,
      proxyPath: '/apps/proxy/gift-card/balance',
      currency: 'AUD',
      strings: {},

      init() {
        const data = this.$root.dataset;
        this.proxyPath = data.proxyPath || this.proxyPath;
        this.currency = data.currency || this.currency;
        this.strings = {
          numberRequired: '',
          pinRequired: '',
          notFound: '',
          rateLimited: '',
          generic: '',
        };
        try {
          const raw = data.errStrings;
          if (raw) {
            const decoder = document.createElement('textarea');
            const decode = (s) => {
              decoder.innerHTML = s;
              return decoder.value;
            };
            const parsed = JSON.parse(raw);
            for (const [k, v] of Object.entries(parsed)) {
              if (k in this.strings) this.strings[k] = typeof v === 'string' ? decode(v) : v;
            }
          }
        } catch (err) {
          console.warn('[gift-card-balance] error strings JSON parse failed:', err);
        }
        this.prefillFromHash();
      },

      /* Prefill the number field from a `#number=...` fragment - the gift
         card email's "View gift card balance" link carries the card number
         there so the customer only has to enter the PIN. The number rides in
         the fragment, never the query string, so it stays out of edge logs
         and out of the Referer sent to page tags; once read we strip it from
         the URL so it does not linger in history. */
      prefillFromHash() {
        const hash = window.location.hash;
        if (!hash || hash.length < 2) return;
        let number = '';
        try {
          number = new URLSearchParams(hash.slice(1)).get('number') || '';
        } catch (e) {
          return;
        }
        number = number.replace(/\s+/g, '');
        if (!number) return;
        const input = this.field('number');
        if (input) input.value = number;
        const url = window.location.pathname + window.location.search;
        window.history.replaceState(window.history.state, '', url);
      },

      field(name) {
        return this.$root.querySelector('[name="' + name + '"]');
      },

      setInvalid(input, on) {
        if (!input) return;
        const wrap = input.closest('.input');
        if (wrap) wrap.classList.toggle('input--error', on);
        input.setAttribute('aria-invalid', on ? 'true' : 'false');
      },

      formatMoney(cents, currency) {
        const amount = Number(cents) / 100;
        if (!isFinite(amount)) return '';
        try {
          return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: currency || this.currency,
          }).format(amount);
        } catch (e) {
          return amount.toFixed(2);
        }
      },

      submitButton() {
        return this.$root.querySelector('.gift-card-balance__submit');
      },

      setBusy(on) {
        this.loading = on;
        const btn = this.submitButton();
        if (!btn) return;
        if (on) {
          btn.setAttribute('disabled', 'true');
          btn.setAttribute('aria-busy', 'true');
        } else {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-busy');
        }
      },

      async check() {
        this.error = '';
        const numberInput = this.field('number');
        const pinInput = this.field('pin');
        const number = (numberInput && numberInput.value || '').replace(/\s+/g, '');
        const pin = (pinInput && pinInput.value || '').trim();

        this.setInvalid(numberInput, false);
        this.setInvalid(pinInput, false);

        if (!number) {
          this.setInvalid(numberInput, true);
          this.error = this.strings.numberRequired;
          if (numberInput) numberInput.focus();
          return;
        }
        if (!pin) {
          this.setInvalid(pinInput, true);
          this.error = this.strings.pinRequired;
          if (pinInput) pinInput.focus();
          return;
        }

        // Write the normalised values back so the form carries clean data.
        if (numberInput) numberInput.value = number;
        if (pinInput) pinInput.value = pin;

        this.setBusy(true);
        this.card = null;
        try {
          // Build the body straight from the form so the browser's own
          // FormData drives the payload; URLSearchParams then serialises it as
          // application/x-www-form-urlencoded (never JSON).
          const body = new URLSearchParams(new FormData(this.$refs.form));
          const res = await fetch(this.proxyPath, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body,
          });

          if (res.status === 429) {
            this.error = this.strings.rateLimited;
            return;
          }
          if (res.status === 422) {
            this.error = this.strings.notFound;
            return;
          }
          if (!res.ok) {
            this.error = this.strings.generic;
            return;
          }

          const data = await res.json();
          if (!data || data.balance == null) {
            this.error = this.strings.notFound;
            return;
          }
          this.card = data;
        } catch (e) {
          this.error = this.strings.generic;
        } finally {
          this.setBusy(false);
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gift-card-recipient"] && !Shopify.designMode) return;
  try {
    /* `Alpine.data('giftCardRecipient', ...)` -- self-contained recipient
     block. Toggles the scheduled-delivery date on the "send later"
     checkbox, keeps a live message counter, and floats the labels on the
     non-Alpine textarea / date primitives. All validation is native; the
     buy-buttons submit reads these `properties[...]` inputs and respects
     their validity. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('giftCardRecipient', () => ({
      init() {
        const root = this.$root;

        const sendLater = root.querySelector('#gc-send-later');
        const date = root.querySelector('#gc-delivery-date');
        const dateWrap = date ? date.closest('.input-date') : null;

        /* Compute the scheduled-delivery ceiling client-side so months are
           calendar-correct.*/
        if (date) {
          const unit = root.dataset.sendMaxUnit;
          const amount = parseInt(
            unit === 'days' ? root.dataset.sendMaxDays : root.dataset.sendMaxMonths,
            10
          );
          if (amount > 0) {
            const max = new Date();
            if (unit === 'days') {
              max.setDate(max.getDate() + amount);
            } else {
              const day = max.getDate();
              max.setDate(1);
              max.setMonth(max.getMonth() + amount);
              const lastDay = new Date(max.getFullYear(), max.getMonth() + 1, 0).getDate();
              max.setDate(Math.min(day, lastDay));
            }
            const pad = (n) => String(n).padStart(2, '0');
            date.max = `${max.getFullYear()}-${pad(max.getMonth() + 1)}-${pad(max.getDate())}`;
          }
        }

        if (sendLater && date) {
          sendLater.addEventListener('change', () => {
            date.disabled = !sendLater.checked;
            if (sendLater.checked) {
              date.setAttribute('required', 'required');
              if (dateWrap) dateWrap.removeAttribute('data-disabled');
            } else {
              date.removeAttribute('required');
              date.value = '';
              if (dateWrap) {
                dateWrap.setAttribute('data-disabled', '');
                dateWrap.removeAttribute('data-has-value');
              }
            }
          });
        }

        const message = root.querySelector('#gc-message');
        if (message) {
          const counter = message.closest('.textarea').querySelector('.textarea__counter');
          message.addEventListener('input', () => {
            if (counter) {
              counter.textContent = counter.textContent.replace(/\d+/, String(message.value.length));
            }
            this.syncHasValue(message);
          });
        }

        root.querySelectorAll('.textarea__control, .input-date__control').forEach((control) => {
          control.addEventListener('input', () => this.syncHasValue(control));
          control.addEventListener('change', () => this.syncHasValue(control));
        });

        /* Keep the hidden `_Design` property in step with the variant
           picker's image. The picker bubbles `variant:change` with the
           resolved variant (or null on deselection); seed value came from
           Liquid so the first paint already matches the server variant.
           `featured_image.src` is the variant's own image when set, else the
           product's first image -- the same fallback the Liquid seed uses.
           Store the domain-relative path only: resolving against the page
           origin normalises absolute and protocol-relative CDN URLs alike,
           then `pathname + search` drops the scheme + host to match the seed. */
        const design = root.querySelector('[data-gc-design]');
        if (design) {
          const designSeed = design.value;
          const toRelative = (src) => {
            try {
              const url = new URL(src, window.location.origin);
              return url.pathname + url.search;
            } catch (error) {
              return src;
            }
          };
          document.addEventListener('variant:change', (event) => {
            const variant = event.detail && event.detail.variant;
            const src = variant && variant.featured_image && variant.featured_image.src;
            design.value = src ? toRelative(src) : designSeed;
          });
        }
      },

      syncHasValue(control) {
        const wrapper = control.closest('.textarea, .input-date');
        if (!wrapper) return;
        if (control.value !== '') {
          wrapper.setAttribute('data-has-value', '');
        } else {
          wrapper.removeAttribute('data-has-value');
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-grouped-selector"] && !Shopify.designMode) return;
  try {
    /* Keyboard forwarder: each label carries tabindex=0 so it's in the tab
     order; Enter/Space toggles the inner radio. Mirrors the variant picker. */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const label = event.target.closest('[data-grouped-option-label]');
    if (!label) return;
    event.preventDefault();
    const input = label.querySelector('[data-grouped-input], [data-switcher-input]');
    if (!input || input.disabled) return;
    input.checked = !input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('alpine:init', () => {
    window.Alpine.data('groupedSelector', () => ({
      map: [],
      axes: [],
      _galleryOriginal: null,
      _galleryCache: {},
      init() {
        try {
          const raw = this.$root.dataset.groupMap;
          if (raw) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = raw;
            this.map = JSON.parse(decoder.value) || [];
          }
        } catch (err) {
          console.warn('[grouped-selector] group map parse failed:', err);
          this.map = [];
        }

        this.axes = Array.from(this.$root.querySelectorAll('[data-option-name]')).map(
          (fieldset) => fieldset.dataset.optionName
        );

        /* Fold each SIBLING point's mirror-stock state into the shared pdp
           store sets so the buy-buttons logic (CTA sold-out gate via
           `oosIds`, quantity cap via `variantMaxMap`) treats a resolved
           sibling variant like one of this product's own. The store is
           init'd first (idempotent, like every other PDP block does) so
           the dataset-seeded sets exist before the merge -- init AFTER the
           merge would replace them and drop the sibling entries. The
           current product's points are skipped: its Liquid-rendered sets
           already carry the authoritative (MOQ-grid-snapped) figures. */
        const pdpStore = window.Alpine.store('pdp');
        const mainRoot = this.$root.closest('[data-main-product]');
        if (pdpStore && mainRoot) {
          pdpStore.init(mainRoot);
          this.map.forEach((entry) => {
            if (entry.current) return;
            const idStr = String(entry.variantId);
            if (!entry.available) pdpStore.oosIds.add(idStr);
            const cap = Number(entry.stockMax);
            if (entry.stockMax != null && Number.isFinite(cap) && !pdpStore.variantMaxMap.has(idStr)) {
              pdpStore.variantMaxMap.set(idStr, cap);
            }
          });
        }

        /* Cache the current product's gallery so an incomplete / cleared
           selection restores it. Strip the ready flag so it re-inits. */
        const host = this.galleryHost();
        this._galleryOriginal = host ? host.innerHTML : null;

        this.$root.querySelectorAll('[data-grouped-input]').forEach((input) => {
          input.addEventListener('change', () => this.onChange());
        });

        /* Re-clicking a checked pill / swatch deselects it. */
        this.$root.addEventListener('click', (event) => {
          if (event.target.matches('[data-grouped-input]')) return;
          const label = event.target.closest('[data-grouped-option-label]');
          if (!label) return;
          const input = label.querySelector('[data-grouped-input]');
          if (!input || input.disabled || !input.checked) return;
          event.preventDefault();
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        window.setTimeout(() => this.emitGroupRange(), 0);
        this.refreshAvailability();
      },

      sectionRoot() {
        return this.$root.closest('[data-main-product]') || document;
      },

      galleryHost() {
        const root = this.sectionRoot();
        const host = root.querySelector('.main-product__gallery');
        if (host) return host;
        const gallery = root.querySelector('.product-gallery');
        return gallery ? gallery.parentElement : null;
      },

      currentSelection() {
        const selection = {};
        this.$root.querySelectorAll('[data-grouped-input]:checked').forEach((input) => {
          selection[input.dataset.axisName] = input.dataset.axisValue;
        });
        return selection;
      },

      /* A point matches a (partial) selection when every selected axis equals
         the point's coordinate on that axis. */
      pointMatches(entry, selection) {
        return Object.keys(selection).every(
          (axis) => entry.coord && entry.coord[axis] === selection[axis]
        );
      },

      /* Grey any value that can't reach an AVAILABLE point given the other
         axes' current selections. Disable-but-visible. */
      refreshAvailability() {
        const selection = this.currentSelection();
        this.$root.querySelectorAll('[data-grouped-input]').forEach((input) => {
          const axis = input.dataset.axisName;
          const test = Object.assign({}, selection, { [axis]: input.dataset.axisValue });
          const viable = this.map.some(
            (entry) => entry.available && this.pointMatches(entry, test)
          );
          input.disabled = !viable;
          input.setAttribute('aria-disabled', viable ? 'false' : 'true');
          const label = input.closest('[data-grouped-option-label]');
          if (label) {
            label.classList.toggle('product-grouped-selector__pill--unavailable', !viable && label.classList.contains('product-grouped-selector__pill'));
            label.classList.toggle('product-grouped-selector__swatch--unavailable', !viable && label.classList.contains('product-grouped-selector__swatch'));
          }
        });
      },

      onChange() {
        const selection = this.currentSelection();

        this.$root.querySelectorAll('[data-grouped-option-display]').forEach((display) => {
          const fieldset = display.closest('[data-option-name]');
          const axis = fieldset && fieldset.dataset.optionName;
          const value = axis ? selection[axis] : null;
          if (value) {
            display.textContent = value;
            display.classList.remove('product-grouped-selector__selected--empty');
          } else {
            display.textContent = display.dataset.placeholder || '';
            display.classList.add('product-grouped-selector__selected--empty');
          }
        });

        const complete = this.axes.length > 0 && this.axes.every((axis) => selection[axis]);
        const store = window.Alpine.store('pdp');
        const root = this.sectionRoot();

        if (complete) {
          const entry = this.map.find((e) => this.pointMatches(e, selection));
          if (entry && entry.available) {
            this.applyEntry(entry, root, store);
          }
        } else {
          if (store) store.setVariantId(null);
          root.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: null }, bubbles: true }));
          this.restoreGallery();
        }

        document.dispatchEvent(
          new CustomEvent('main-options:change', {
            detail: { productId: store && store.productId, values: selection },
          })
        );

        this.refreshAvailability();
      },

      /* Point the ATC + dependent surfaces at the resolved (sibling, variant)
         without a reload. The variant id is all `/cart/add.js` needs, so a
         sibling's SKU adds correctly from the current product's page. */
      applyEntry(entry, root, store) {
        const hidden = root.querySelector('[data-product-variant-id]');
        if (hidden) hidden.value = String(entry.variantId);

        const form = root.querySelector('[data-product-form]');
        if (form) {
          if (entry.dec) form.dataset.decClassification = entry.dec;
          else delete form.dataset.decClassification;
        }

        if (store) store.setVariantId(entry.variantId);

        root.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: { variant: { id: entry.variantId, price: entry.price, compare_at_price: entry.compareAt } },
            bubbles: true,
          })
        );

        this.swapGallery(entry);
      },

      /* Full cross-sibling gallery repaint via the Section Rendering API:
         fetch the sibling's gallery rendered for the resolved variant
         (`product-gallery-standalone`) and swap it in. Server rendering reuses
         the gallery's Liquid (media map / badges / zoom / grid modes) that the
         JS payload can't reconstruct. The current product's own point restores
         the original gallery. */
      async swapGallery(entry) {
        const host = this.galleryHost();
        if (!host) return;
        if (entry.current) {
          this.restoreGallery();
          return;
        }
        const cacheKey = String(entry.variantId);
        try {
          let html = this._galleryCache[cacheKey];
          if (html == null) {
            const url =
              window.location.origin +
              '/products/' +
              encodeURIComponent(entry.handle) +
              '?variant=' +
              encodeURIComponent(entry.variantId) +
              '&section_id=product-gallery-standalone';
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('gallery fetch ' + response.status);
            html = await response.text();
            this._galleryCache[cacheKey] = html;
          }
          this.injectGallery(host, html);
        } catch (err) {
          console.warn('[grouped-selector] gallery swap failed:', err);
        }
      },

      restoreGallery() {
        const host = this.galleryHost();
        if (host && this._galleryOriginal != null) {
          this.injectGallery(host, this._galleryOriginal);
        }
      },

      /* Parse the section HTML, unwrap a shopify-section wrapper if present,
         strip the gallery's ready flag so Alpine re-inits it, then inject. */
      injectGallery(host, html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const wrapper = doc.querySelector('.shopify-section');
        const source = wrapper || doc.body;
        const gallery = source.querySelector('.product-gallery');
        if (gallery) gallery.removeAttribute('data-gallery-ready');
        host.innerHTML = source.innerHTML;
      },

      emitGroupRange() {
        const ds = this.$root.dataset;
        this.sectionRoot().dispatchEvent(
          new CustomEvent('pdp:group-range', {
            detail: {
              priceMin: Number(ds.groupPriceMin),
              priceMax: Number(ds.groupPriceMax),
              compareMin: Number(ds.groupCompareMin),
              compareMax: Number(ds.groupCompareMax),
            },
            bubbles: true,
          })
        );
      },
    }));

    /* GRID template controller: a size switcher over sibling products.
       Each size is a separate product with its own colour grid, so selecting
       a size navigates to that sibling's page. A full load keeps the grid,
       gallery, price, breadcrumb, wishlist, find-in-store and browser history
       all correct — nothing is swapped in place to go stale. No availability
       gating or ATC sync here (that's the merged picker's job on non-grid
       templates). */
    window.Alpine.data('groupedSizeSwitcher', () => ({
      roster: [],
      init() {
        try {
          const raw = this.$root.dataset.sizeRoster;
          if (raw) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = raw;
            this.roster = JSON.parse(decoder.value) || [];
          }
        } catch (err) {
          console.warn('[grouped-switcher] roster parse failed:', err);
          this.roster = [];
        }
        this.$root.querySelectorAll('[data-switcher-input]').forEach((input) => {
          input.addEventListener('change', () => this.onSwitch());
        });
      },

      currentSelection() {
        const selection = {};
        this.$root.querySelectorAll('[data-switcher-input]:checked').forEach((input) => {
          selection[input.dataset.axisName] = input.dataset.axisValue;
        });
        return selection;
      },

      siblingFor(selection) {
        return this.roster.find(
          (sib) => sib.coord && Object.keys(selection).every((axis) => sib.coord[axis] === selection[axis])
        );
      },

      onSwitch() {
        const selection = this.currentSelection();
        const sib = this.siblingFor(selection);
        if (!sib || sib.current || !sib.url) return;
        window.location.assign(sib.url);
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-offer-banners"] && !Shopify.designMode) return;
  try {
    /* Live volume-banner behaviour, driven by the quantity selector's and the
     variant picker's bubbling events (not the Alpine store), so it works
     whether or not the price block is present.

     - quantity:change moves the active-bracket emphasis so the banner agrees
       with the buy box.
     - variant:change re-prices the ladder. Rows are server-rendered for the
       load-time variant (or in percentage form when none was chosen), so a
       client-side switch would otherwise leave stale money figures - or the
       percentage form - for the newly selected variant. Each row carries its
       floor + percentage; the localised money template (VT_RANGE / VT_PRICE
       sentinels) rebuilds "Buy N for $X each" with the same CEIL the Function
       and `volume-tier-rows` use, so the panel stays in step with checkout. */
  (() => {
    const rowFloor = (row) => {
      const attr = row.getAttribute('data-vt-floor');
      if (attr !== null) return Number.parseInt(attr, 10);
      const match = row.textContent.match(/(\d+)/);
      return match ? Number.parseInt(match[1], 10) : 0;
    };

    const highlightActiveBracket = (card, quantity) => {
      const rows = [...card.querySelectorAll('.volume-tier-rows__row')];
      if (rows.length === 0) return;
      /* Rows are in ascending bracket order; the last row at or below the
         quantity is the active one. The synthesised full-price row (present
         only when the lowest floor is above 1) is row 0 and stays active until
         the first bracket is reached. */
      const floors = rows.map(rowFloor);
      let activeIndex = 0;
      for (let rowIndex = 0; rowIndex < floors.length; rowIndex += 1) {
        if (quantity >= floors[rowIndex]) activeIndex = rowIndex;
      }
      rows.forEach((row, rowIndex) => {
        row.classList.toggle('volume-tier-rows__row--active', rowIndex === activeIndex);
      });
    };

    const formatMoney = (cents) =>
      '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const repriceLadder = (list, unitPriceCents) => {
      const template = list.getAttribute('data-volume-money-template');
      if (!template || !Number.isFinite(unitPriceCents) || unitPriceCents <= 0) return;
      list.querySelectorAll('.volume-tier-rows__row').forEach((row) => {
        const percent = Number(row.getAttribute('data-vt-percent'));
        const range = row.getAttribute('data-vt-range');
        if (!Number.isFinite(percent) || range === null) return;
        /* round: 4 to kill float noise, then CEIL in cents - mirrors
           volume-tier-rows.liquid so advertised equals charged. */
        const raw = (unitPriceCents * (100 - percent)) / 100;
        const cents = Math.ceil(Math.round(raw * 10000) / 10000);
        row.textContent = template.replace('VT_RANGE', range).replace('VT_PRICE', formatMoney(cents));
      });
    };

    document.addEventListener('quantity:change', (event) => {
      const quantity = Number(event.detail?.value);
      if (!Number.isFinite(quantity)) return;
      document
        .querySelectorAll('[data-volume-tier-card]')
        .forEach((card) => highlightActiveBracket(card, quantity));
    });

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      const price = variant ? Number(variant.price) : NaN;
      document
        .querySelectorAll('[data-volume-tier-card] .volume-tier-rows[data-volume-money-template]')
        .forEach((list) => repriceLadder(list, price));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-price"] && !Shopify.designMode) return;
  try {
    /* `productPrice` — shows the product range until a variant is committed,
     then that variant's single price + compare-at. Seeded from SSR, then
     advanced by the picker's bubbling `variant:change` (`{ variant }` on a
     pick, `{ variant: null }` when incomplete → back to the range). Getters
     mirror snippets/price.liquid — keep in sync. Listener scoped to the
     main-product section so the global quick-add drawer can't leak in. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('productPrice', () => ({
      /* null → show the product range; a variant object → its single price. */
      activeVariant: null,
      range: null,
      /* Ascending [{minQuantity, percentage}] from the live volume_tier discount; empty when
         none covers this product, which makes every tier getter inert. */
      volumeTiers: [],
      /* Variant ids the volume offer is limited to. Empty means the offer
         matched at product level and every variant is covered. */
      volumeGateVariantIds: [],
      /* Percent-off badge copy. `saleProductLabel` is the whole-product
         "Up To X% Off" shown until a variant is committed; `saleLabelTemplate`
         is the localised "__PERCENT__% Off" pattern the getter fills per
         variant. */
      saleProductLabel: '',
      saleLabelTemplate: '',
      /* Members discount percentage and the variant ids it is limited to
         (empty = every variant). Sourced from the same projection surface as
         the server render, so the badge cannot change figure on hydration. */
      membersPercentage: 0,
      membersGateVariantIds: [],
      /* Product-level members range extremes (final discounted cents) for a
         subset-covered offer: covered variants discounted, uncovered left
         regular. Used only in the uncommitted range state, so a partial offer
         shows the true covered/uncovered range instead of discounting the whole
         range. null when coverage is full or nothing matched → the range is
         derived from the percentage. Matches the card's product-level range. */
      membersRange: null,
      init() {
        const dataset = this.$el.dataset;
        this.saleProductLabel = dataset.saleProductLabel || '';
        this.saleLabelTemplate = dataset.saleLabelTemplate || '';
        this.membersPercentage = Number(dataset.membersPercentage) || 0;
        this.membersGateVariantIds = (dataset.membersGateVariantIds || '')
          .split(',')
          .map((variantId) => variantId.trim())
          .filter(Boolean);
        const membersRangeMin = Number(dataset.membersRangeMin);
        const membersRangeMax = Number(dataset.membersRangeMax);
        if (membersRangeMin > 0 || membersRangeMax > 0) {
          this.membersRange = { min: membersRangeMin, max: membersRangeMax };
        }
        this.volumeGateVariantIds = (dataset.volumeGateVariantIds || '')
          .split(',')
          .map((variantId) => variantId.trim())
          .filter(Boolean);
        this.volumeTiers = (dataset.volumeTiers || '')
          .split(',')
          .map((bracketPair) => {
            const [minQuantity, percentage] = bracketPair.split(':');
            return {
              minQuantity: Number.parseInt(minQuantity, 10),
              percentage: Number(percentage),
            };
          })
          .filter(
            (bracket) =>
              Number.isInteger(bracket.minQuantity) &&
              bracket.minQuantity >= 1 &&
              Number.isFinite(bracket.percentage) &&
              bracket.percentage > 0 &&
              bracket.percentage <= 100,
          )
          .sort((first, second) => first.minQuantity - second.minQuantity);
        this.range = {
          varies: dataset.priceVaries === 'true',
          priceMin: Number(dataset.priceMin),
          priceMax: Number(dataset.priceMax),
          compareMin: Number(dataset.compareMin),
          compareMax: Number(dataset.compareMax),
        };
        if (dataset.hasCommittedVariant === 'true') {
          const initialPrice = Number(dataset.initialPrice);
          this.activeVariant = {
            /* Carried so the volume gate can identify the SSR-seeded variant
               before the picker fires its first variant:change. */
            id: dataset.initialVariantId,
            price: Number.isFinite(initialPrice) ? initialPrice : 0,
            compare_at_price: dataset.initialCompare ? Number(dataset.initialCompare) : null,
          };
        }
        const variantScope = this.$el.closest('[data-main-product]') || document;
        this._onVariantChange = (event) => {
          this.activeVariant = (event.detail && event.detail.variant) || null;
        };
        variantScope.addEventListener('variant:change', this._onVariantChange);

        /* Grouped products span multiple sibling products, so the price
           row's range must cover the whole group, not just this product
           (a single flattened sibling has price_varies == false). The
           grouped selector emits the group-wide min/max on mount; adopt it
           and drop the committed seed so the row shows the group range
           until a coordinate resolves. */
        this._onGroupRange = (event) => {
          const detail = event.detail || {};
          this.range = {
            varies: Number(detail.priceMin) !== Number(detail.priceMax),
            priceMin: Number(detail.priceMin),
            priceMax: Number(detail.priceMax),
            compareMin: Number(detail.compareMin) || 0,
            compareMax: Number(detail.compareMax) || 0,
          };
          /* The partial extremes were resolved for THIS product's variants; a
             group-wide range spans siblings, so they no longer apply - fall
             back to deriving the members range from the percentage. */
          this.membersRange = null;
          this.activeVariant = null;
        };
        variantScope.addEventListener('pdp:group-range', this._onGroupRange);
        this._variantScope = variantScope;
      },
      destroy() {
        if (this._variantScope) {
          this._variantScope.removeEventListener('variant:change', this._onVariantChange);
          this._variantScope.removeEventListener('pdp:group-range', this._onGroupRange);
        }
      },
      /* Range shown only while no variant is committed and prices vary. */
      get isRange() {
        return !this.activeVariant && !!(this.range && this.range.varies);
      },
      /* Percent-off badge label. A committed variant shows its own floored "X%
         Off" (mirrors sale-badge), falling back to the members percentage when
         it carries no markdown, and hidden when neither applies; with no
         variant committed, the whole-product "Up To" label. Integer maths to
         match the Liquid `divided_by` floor. Same precedence as `sale-badge` -
         markdown first - so a repaint can never disagree with the server
         render. */
      get saleBadgeLabel() {
        const variant = this.activeVariant;
        if (variant) {
          const compare = Number(variant.compare_at_price);
          const price = Number(variant.price);
          if (Number.isFinite(compare) && compare > price) {
            const percentOff = Math.floor(((compare - price) * 100) / compare);
            if (percentOff > 0) return this.saleLabelTemplate.replace('__PERCENT__', percentOff);
          }
          if (this.membersPercentage > 0 && this.isMembersVariant(variant)) {
            return this.saleLabelTemplate.replace('__PERCENT__', this.membersPercentage);
          }
          return '';
        }
        return this.saleProductLabel || '';
      },
      /* Variant-targeted members offer: only the listed variants may show the
         members percentage. Empty gate = product-level match, every variant
         covered. Mirrors `activeTier`'s guard on the volume ladder. */
      isMembersVariant(variant) {
        if (this.membersGateVariantIds.length === 0) return true;
        return this.membersGateVariantIds.includes(String(variant.id));
      },
      /* Members price state, bound by `price`. With no variant committed, the
         product-level state shows for any live members offer - a full-coverage
         one as the whole shifted range, a subset one as the covered/uncovered
         extremes (`membersRange`), matching the card's product-level treatment.
         Once committed, the variant must be full price AND in the gate - same
         two conditions the colour grid applies per card - so a pick onto an
         uncovered or marked-down variant falls back to the plain price. */
      get showMembersPrice() {
        if (this.membersPercentage <= 0) return false;
        const variant = this.activeVariant;
        if (!variant) return true;
        const compare = Number(variant.compare_at_price);
        if (Number.isFinite(compare) && compare > Number(variant.price)) return false;
        return this.isMembersVariant(variant);
      },
      /* Members figure(s). Math.round matches the Liquid `| round` in
         members-price, so the SSR seed and this repaint print the same cent.
         Ranges mirror `displayPrice`: a range only while nothing is committed. */
      get displayMembersPrice() {
        const formatMoney = (cents) => this.$store.pdp.formatMoney(cents);
        const applyPercentage = (cents) =>
          Math.round((Number(cents) * (100 - this.membersPercentage)) / 100);
        const variant = this.activeVariant;
        if (variant) return formatMoney(applyPercentage(variant.price));
        if (!this.range) return '';
        /* Subset-covered offer: the producer resolved the true extremes
           (covered variants discounted, uncovered left regular), so print them
           directly rather than discounting the whole range, which would
           understate the uncovered ceiling. */
        if (this.membersRange) {
          return this.range.varies
            ? formatMoney(this.membersRange.min) + ' - ' + formatMoney(this.membersRange.max)
            : formatMoney(this.membersRange.min);
        }
        if (this.range.varies) {
          return (
            formatMoney(applyPercentage(this.range.priceMin)) +
            ' - ' +
            formatMoney(applyPercentage(this.range.priceMax))
          );
        }
        return formatMoney(applyPercentage(this.range.priceMin));
      },
      /* Highest bracket at or below the current quantity, or null.
         Requires a committed variant (a range has no unit price to discount)
         and a full-price line: the Function suppresses on-sale lines,
         so a marked-down variant must never show a tiered price here. Reads
         $store.pdp.quantity, which buy-buttons keeps in step with the
         quantity selector - that store read is what makes this reactive. */
      get activeTier() {
        const variant = this.activeVariant;
        if (!variant || this.volumeTiers.length === 0) return null;
        if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
          return null;
        }
        /* Variant-targeted offer: the picker can move the row onto a variant
           the discount does not cover, and checkout would charge full price
           for it. Bail rather than advertise a discount that will not apply. */
        if (
          this.volumeGateVariantIds.length > 0 &&
          !this.volumeGateVariantIds.includes(String(variant.id))
        ) {
          return null;
        }
        const quantity = Number(this.$store.pdp.quantity) || 1;
        let matchedBracket = null;
        for (const bracket of this.volumeTiers) {
          if (quantity >= bracket.minQuantity) matchedBracket = bracket;
        }
        return matchedBracket;
      },
      /* Unit price under the active bracket, in cents. Mirrors the Liquid ladder
         (`volume-tier-rows`) so the rows and the price row always print the same
         figure - CEIL, because Shopify truncates the per-unit discount at
         checkout (verified on staging: $16.75 less 25% is charged as $12.57).
         Rounded to 4dp first so float noise cannot ceil an extra cent. */
      get tieredPrice() {
        const bracket = this.activeTier;
        if (!bracket) return null;
        const remainder = (this.activeVariant.price * (100 - bracket.percentage)) / 100;
        return Math.ceil(Number(remainder.toFixed(4)));
      },
      get isOnSale() {
        /* A live bracket shows like a markdown: tiered price now, the regular
           unit price struck through. Mutually exclusive with a real sale by
           the activeTier guard above. */
        if (this.activeTier) return true;
        const variant = this.activeVariant;
        if (variant) {
          return !!(variant.compare_at_price != null && variant.compare_at_price > variant.price);
        }
        const range = this.range;
        if (!range) return false;
        const floorDrop = range.compareMin > 0 && range.priceMin < range.compareMin;
        if (!range.varies) return floorDrop;
        const ceilingDrop = range.compareMax > range.priceMax;
        return floorDrop || ceilingDrop;
      },
      get displayPrice() {
        const formatMoney = (cents) => this.$store.pdp.formatMoney(cents);
        const tieredPrice = this.tieredPrice;
        if (tieredPrice != null) return formatMoney(tieredPrice);
        const variant = this.activeVariant;
        if (variant) return formatMoney(variant.price);
        const range = this.range;
        if (!range) return '';
        return range.varies
          ? formatMoney(range.priceMin) + ' - ' + formatMoney(range.priceMax)
          : formatMoney(range.priceMin);
      },
      get displayCompare() {
        const formatMoney = (cents) => this.$store.pdp.formatMoney(cents);
        const variant = this.activeVariant;
        if (this.activeTier) return formatMoney(variant.price);
        if (variant) {
          return variant.compare_at_price == null ? '' : formatMoney(variant.compare_at_price);
        }
        const range = this.range;
        if (!range) return '';
        return range.varies
          ? formatMoney(range.compareMin) + ' - ' + formatMoney(range.compareMax)
          : formatMoney(range.compareMin);
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    /* Each `<label>` carries tabindex=0 so every option is in the tab order
     (radios share a single tab stop by default). Labels don't fire `change`
     from keyboard Enter/Space natively, so forward those keys to the inner
     radio. */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const label = event.target.closest('[data-variant-option-label]');
    if (!label) return;
    event.preventDefault();
    const input = label.querySelector('[data-variant-option-input]');
    if (!input || input.disabled) return;
    if (input.checked) {
      /* Pills can be toggled off; other option types stay select-only. */
      if (!label.classList.contains('product-variant-picker__pill')) return;
      input.checked = false;
    } else {
      input.checked = true;
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* `Alpine.data('variantPicker', ...)` -- option-selection logic.
     Mounts via `x-data="variantPicker"` on the picker block root
     (absent on the Singular Variant view of the grid template). On any
     option change: updates the legend display, broadcasts the partial
     selection as the document `main-options:change` event (consumed by
     the colour-variant cards section), resolves the matching variant
     from the cached `/products/{handle}.js` payload, and writes the
     id to `$store.pdp.variantId`. Listens for `pdp:payload` so the
     payload arrival re-resolves any selection the user made while the
     fetch was in flight. */
  document.addEventListener('alpine:init', () => {
    window.Alpine.data('variantPicker', () => ({
      /* Reactive SKU state — bound to the row via `x-text` + `x-show`
         so the label + value visibility flip together. Seeded from the
         server-rendered value so a URL-selected variant with a real SKU
         doesn't flash empty before Alpine hydrates. */
      sku: '',
      init() {
        const store = this.$store.pdp;
        store.init(this.sectionRoot());

        const initialSkuNode = this.$root.querySelector('[data-product-sku]');
        if (initialSkuNode) this.sku = initialSkuNode.textContent.trim();

        const inputs = this.$root.querySelectorAll('[data-variant-option-input]');
        inputs.forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange());
        });

        /* Re-clicking the already-selected pill deselects it (radios can't
           toggle off natively): cancel the label's re-check, uncheck, fire
           change. Ignore the synthesized click a label fires on its own
           radio (target is the input) so selecting a fresh pill isn't
           immediately undone. */
        this.$root.addEventListener('click', (event) => {
          if (event.target.matches('[data-variant-option-input]')) return;
          const pill = event.target.closest('.product-variant-picker__pill');
          if (!pill) return;
          const input = pill.querySelector('[data-variant-option-input]');
          if (!input || input.disabled || !input.checked) return;
          event.preventDefault();
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        const initiallyChecked = this.$root.querySelectorAll(
          '[data-variant-option-input]:checked'
        );
        if (initiallyChecked.length > 0) {
          this.broadcastMainOptions(initiallyChecked);
        }

        document.addEventListener('pdp:payload', () => {
          this.rehydrateFromSelection();
          this.refreshAvailability();
        });

        /* First availability pass may run before the payload has landed
           — `hasVariantForPartial` returns true when the store's payload
           is null, so the inputs stay enabled until the JSON arrives. */
        this.refreshAvailability();
      },

      sectionRoot() {
        return this.$root.closest('[data-main-product]') || this.$root;
      },

      collectCheckedSorted() {
        return Array.from(
          this.$root.querySelectorAll('[data-variant-option-input]:checked')
        ).sort(
          (a, b) =>
            Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
        );
      },

      /* Builds the `{ [1-based position]: value }` selection used to
         drive the "is this reachable?" query. In grid_mode the picker
         hides the colour option, so the wrapper carries
         `data-fixed-selection` (a JSON array of the URL variant's
         options); those values seed the selection first, then any
         checked pill / swatch overrides its own position. */
      buildSelection() {
        const selection = {};
        const raw = this.$root.dataset.fixedSelection;
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
              parsed.forEach((value, index) => {
                if (value != null) selection[index + 1] = value;
              });
            }
          } catch (error) {
            /* malformed JSON — ignore and fall back to just the picks */
          }
        }
        this.$root
          .querySelectorAll('[data-variant-option-input]:checked')
          .forEach((input) => {
            selection[input.dataset.optionPosition] = input.dataset.optionValue;
          });
        return selection;
      },

      /* For every rendered radio, decide whether picking its value —
         with the currently-checked values at OTHER positions still in
         place — would produce a real variant. Values that can't reach
         any variant get `disabled` + `aria-disabled` on the input and
         a `--unavailable` modifier on the label so the CSS mutes them.
         The check honours in-flight payloads: `hasVariantForPartial`
         returns true before the payload lands, keeping the picker
         open until we have the data to prune it. */
      refreshAvailability() {
        const store = this.$store.pdp;
        if (!store) return;
        const selection = this.buildSelection();

        this.$root
          .querySelectorAll('[data-variant-option-input]')
          .forEach((input) => {
            const testSelection = Object.assign({}, selection, {
              [input.dataset.optionPosition]: input.dataset.optionValue,
            });
            const viable = store.hasVariantForPartial(testSelection);
            input.disabled = !viable;
            input.setAttribute('aria-disabled', viable ? 'false' : 'true');

            const label = input.closest('[data-variant-option-label]');
            if (!label) return;
            label.classList.toggle(
              'product-variant-picker__pill--unavailable',
              !viable && label.classList.contains('product-variant-picker__pill')
            );
            label.classList.toggle(
              'product-variant-picker__swatch--unavailable',
              !viable && label.classList.contains('product-variant-picker__swatch')
            );
          });
      },

      broadcastMainOptions(inputs) {
        const values = {};
        inputs.forEach((input) => {
          values[input.dataset.optionPosition] = input.dataset.optionValue;
        });
        document.dispatchEvent(
          new CustomEvent('main-options:change', {
            detail: { productId: this.$store.pdp.productId, values },
          })
        );
      },

      rehydrateFromSelection() {
        const checked = this.collectCheckedSorted();
        if (checked.length === 0) return;
        const values = checked.map((input) => input.dataset.optionValue);
        const match = this.$store.pdp.resolveVariantFromValues(values);
        if (match) this.$store.pdp.setVariantId(match.id);
      },

      onOptionChange() {
        const inputs = this.collectCheckedSorted();
        const values = inputs.map((input) => input.dataset.optionValue);

        /* Update every group's legend — selected groups show their value,
           now-empty groups (after a deselect) revert to the placeholder. */
        this.$root.querySelectorAll('[data-variant-option-display]').forEach((display) => {
          const pos = display.dataset.variantOptionDisplay;
          const checked = this.$root.querySelector(
            `[data-variant-option-input][data-option-position="${pos}"]:checked`
          );
          if (checked) {
            display.textContent = checked.dataset.optionValue;
            display.classList.remove('product-variant-picker__selected--empty');
          } else {
            display.textContent = display.dataset.placeholder || '';
            display.classList.add('product-variant-picker__selected--empty');
          }
        });

        this.broadcastMainOptions(inputs);

        const store = this.$store.pdp;
        const root = this.sectionRoot();
        if (store.productPayload) {
          const match = store.resolveVariantFromValues(values);
          if (match) {
            store.setVariantId(match.id);
            const hidden = root.querySelector('[data-product-variant-id]');
            if (hidden) hidden.value = String(match.id);

            /* Reactive: the row's `x-text` + `x-show` bindings pick this
               up and hide the entire wrapper (label + value) when the
               resolved variant has no SKU string in the admin. */
            this.sku = match.sku || '';

            const titleNode = root.querySelector('[data-product-variant-title]');
            if (titleNode) titleNode.textContent = match.public_title || match.title;

            this.updateUrl(match.id);
            this.$dispatch('variant:change', { variant: match, productId: store.productPayload && store.productPayload.id });
          } else {
            store.setVariantId(null);
            /* Announce deselection too (Issue 5): variant-gated placements
               (badges, banners, members price, volume table) hide when no
               variant resolves, not just when the wrong one does. */
            this.$dispatch('variant:change', { variant: null });
            this.sku = '';
            /* Drop a stale ?variant= so a deselect survives a refresh. */
            this.clearUrl();
          }
        }

        this.refreshAvailability();
      },

      updateUrl(variantId) {
        if (!window.history || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        window.history.replaceState({}, '', url.toString());
      },

      clearUrl() {
        if (!window.history || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        if (!url.searchParams.has('variant')) return;
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.toString());
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
